import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { MobileSecurityCustomerViewDataProvider } from '../dataProvider/MobileSecurityCustomerViewDataProvider';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MobileSecurityCustomerViewDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MobileSecurityCustomerViewDataProvider);
  }
}
